var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99296 6.1992C5.99296 4.60814 6.6251 3.08143 7.75007 1.95633C8.87504 0.83122 10.4018 0.199219 11.9929 0.199219C13.5841 0.199219 15.1107 0.831357 16.2358 1.95633C17.3609 3.0813 17.9929 4.60809 17.9929 6.1992C17.9929 7.79032 17.3608 9.31697 16.2358 10.4421C15.1109 11.5672 13.5841 12.1992 11.9929 12.1992C10.4019 12.197 8.87737 11.5649 7.75226 10.4399C6.62727 9.31491 5.99513 7.79026 5.99296 6.1992ZM22.0215 21.0834C21.8993 20.5649 21.7301 20.0581 21.5158 19.5695C19.9879 16.0809 16.3398 13.9135 11.9929 13.9135C7.05806 13.9135 3.03817 16.7625 1.98712 21.0021C1.79641 21.7714 1.97105 22.5846 2.45856 23.2092C2.94604 23.8328 3.6939 24.1981 4.48674 24.1992H19.5037C20.2987 24.2014 21.0508 23.836 21.5426 23.2103C22.0205 22.6124 22.1972 21.828 22.0215 21.0834Z",
    fill: "#475569"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.4dcd9adbd681cafe03bd5b0e4eb20241.svg";
export { ForwardRef as ReactComponent };